/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_I2Inputs */

const tr_kullanim_s4_i2 = /** @type {(inputs: Kullanim_S4_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt bilgilerinin doğru, güncel ve eksiksiz olması Kullanıcı sorumluluğundadır.`)
};

const en_kullanim_s4_i2 = /** @type {(inputs: Kullanim_S4_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the User's responsibility that the registration details are accurate, up to date and complete.`)
};

const de_kullanim_s4_i2 = /** @type {(inputs: Kullanim_S4_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer ist dafür verantwortlich, dass die Registrierungsangaben richtig, aktuell und vollständig sind.`)
};

const ru_kullanim_s4_i2 = /** @type {(inputs: Kullanim_S4_I2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь несёт ответственность за достоверность, актуальность и полноту регистрационных данных.`)
};

/**
* | output |
* | --- |
* | "It is the User's responsibility that the registration details are accurate, up to date and complete." |
*
* @param {Kullanim_S4_I2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_i2 = /** @type {((inputs?: Kullanim_S4_I2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_I2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_i2(inputs)
	if (locale === "de") return de_kullanim_s4_i2(inputs)
	if (locale === "ru") return ru_kullanim_s4_i2(inputs)
	return tr_kullanim_s4_i2(inputs)
});